<template>
  <form @submit.prevent="stopEditing" class="more-icons">
    <button class="no-btn" v-for="(icon, index) in this.icons" :key="index">
      <BaseIcon :name="[icon.prefix, icon.name]" />
      <span>{{ capitalize(icon.icon) }}</span>
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon
  },
  props: {
    icons: Array
  },
   
  methods: {
    capitalize([firstLetter, ...rest]) {
      return [firstLetter.toLocaleUpperCase(), ...rest].join("");
    },
    moreIcons(index) {
      this.parts[index].more = !this.parts[index].more;

      // Refresh object
      Object.assign(this.$data, this.$options.data.call(this));
    },
    startEditing() {
      this.isEditing = true;
    },
    newIcon: function() {
    },
    stopEditing() {
      this.isEditing = false;
      this.putCustomValues();
      this.$emit("refresh", true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/buttons";
$triangle-size: 10px;

form.more-icons {
  position: absolute;
  bottom: calc(50% + 20px);
  right: -31px;
  display: flex;
  flex-direction: column;
  background-color: $whitest-grey;
  border: 1px solid $light-grey;
  border-radius: 6px;
  button {
    cursor: pointer;
    display: flex;
    padding: 10px;
    color: $dark-primary-color;
    span {
      margin-left: 10px;
    }
    & + button {
      border-top: 1px solid $light-grey;
    }
  }
  &:before {
    position: absolute;
    content: "";
    bottom: -#{$triangle-size};
    left: calc(50% - #{$triangle-size});
    // transform: rotate(45deg);
    
    width: 0;
    height: 0;
    border-left: #{$triangle-size - 3px} solid transparent;
    border-right: #{$triangle-size - 3px} solid transparent;
    border-top: $triangle-size solid $light-grey;
  }
}
</style>
